function GameRates({games}) {

    return (
        <section className="game-rates-section">
            <div className="container">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="game-rates-header text-center">
                            <div className="section-heading-branded">
                                <span className="section-heading-branded__star" aria-hidden="true">⭐</span>
                                <h2 className="section-heading-branded__text mb-0">Game Rates</h2>
                                <span className="section-heading-branded__star" aria-hidden="true">⭐</span>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-12">
                        <div className="game-rates-container">
                            <div className="row g-3">
                                {
                                    games.map((game, index) => {
                                        return (
                                            <div className="col-lg-4 col-md-6" key={index}>
                                                <div className="game-rate-card">
                                                    <div className="game-rate-content">
                                                        <h3 className="game-rate-name">{game.name}</h3>
                                                        <div className="game-rate-amount">
                                                            <span className="game-rate-label">1 RS KA</span>
                                                            <span className="game-rate-value">{game.rate} Rs</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        )
                                    })
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

    );
}

export default GameRates;